<template>
    <div v-if="getShowBool()">
        <a :href="createSamTechUrl(row)">
            {{ getSamTechVehicle(row.VechicleId) }} #{{ row.VechicleId }}
        </a>
    </div>
</template>


<script>
import moment from "moment";

// Add regex formatting to strings to enable us to format samtech stuff
const fmt = (tpl, ...args) => tpl.replace(/{(\d+)}/g, (_, n) => args[n] ?? _);

export default {
    name: 'SamTechIndicator',
    props: {
        samtechConfig: Object,
        row: Object,
    },
    components: {},

    data() {
        return {};
    },

    methods: {
        getShowBool() {
            return this.row.ArticleNumber === this.samtechConfig.DefaultWorkArticle
                && (this.row.VechicleId && this.row.VechicleId.trim().length > 0);
        },

        getSamTechVehicle(vehicleId) {
            if (!this.samtechConfig.GpsVehicles || !vehicleId) return "SamTech";
            const trimmedVehicleId = vehicleId.trim();
            const vehicle = this.samtechConfig.GpsVehicles.find((f) => f.Id === trimmedVehicleId);
            if (vehicle != null) {
                return vehicle.Name;
            }
            return "Unknown";
        },

        createSamTechUrl(item) {
            const base = this.samtechConfig.SamtechGpsUrlbase;
            const baseUser = this.samtechConfig.SamtechUser;
            const basePw = this.samtechConfig.SamtechPw;
            const baseName = this.samtechConfig.SamtechName;
            const vehicleId = item.VechicleId;
            const now = moment(new Date()).format("YYYYMMDDHHmmss");
            const startDate = moment(item.StartDateTime).format("YYYYMMDDHHmmss");
            const stopDate = moment(item.StopDateTime).format("YYYYMMDDHHmmss");
            // validate and give good errors :)
            if (!vehicleId) throw 'Missing "VehicleId" member!';
            if (!basePw || !baseUser) throw "Missing credentials!";

            const formattedString = fmt(base, baseUser, basePw, encodeURI(vehicleId.trim()), startDate, stopDate, now);

            console.log(baseName, vehicleId, "start", startDate, stopDate, now);
            return formattedString;
        },
    },

    computed: {},

    watch: {},
};
</script>


<style lang='scss' scoped></style>